import { observable, makeObservable } from 'mobx';
import {DomainObject} from 'shared/store';

class OfferTemplateSummary extends DomainObject {
  name;

  constructor(other) {
    super();

    makeObservable(this, {
      name: observable
    });

    this.merge(other);
  }
}

export default OfferTemplateSummary;
